import { render, staticRenderFns } from "./CircleChartWithDescriptions.vue?vue&type=template&id=7ed91e3e&scoped=true&"
import script from "./CircleChartWithDescriptions.vue?vue&type=script&lang=ts&"
export * from "./CircleChartWithDescriptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed91e3e",
  null
  
)

export default component.exports